export default String.raw`
<div class="cart-row header-row">
	<div class="cart-row__number">
		{{translations.ShortNumber}}
	</div>

    <div class="cart-row__product">
     	{{translations.CartProduct}}
    </div>
		
    <div class="cart-row__price">
		{{translations.Price}}
		{% if config.ENTERPRISE or cart.SubtotalPrices -%}
			{{translations.Netto | Downcase }}
		{% else -%}
			{{translations.Brutto | Downcase }}
		{% endif -%}
    </div>

    {% if config.ENTERPRISE -%}
    	<div class="cart-row__total-price">
			{{translations.Price}} {{translations.Brutto | Downcase}}
    	</div>
    {% endif -%}

	{% if cart.TotalDepositValue > 0 -%}
	    <div class="cart-row__deposit-price">
			{{translations.Com_Deposit}}
    	</div>
	{% endif -%}

    <div class="cart-row__quantity">
		{{translations.Quantity}}
	</div>

    <div class="cart-row__value">
		{% if config.ENTERPRISE -%}
			{% if cart.SubtotalPrices -%}
				{{translations.Value}} {{translations.Netto | Downcase }}
			{% else -%}
				{{translations.Value}} {{translations.Brutto | Downcase }}
			{% endif -%}
		{% endif -%}
	</div>

    <div class="cart-row__currency">
		{{translations.Currency}}
	</div>

    <div class="cart-row__options options-column-js select-wcag-js">
		<button aria-label="{{translations.Options}}" class="cart-row__more-btn div-table-options-js">
			<svg>
                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#ellipsis-v-{{settings.iconStyle}}"></use>
            </svg>
		</button>
		<ul class="cart-row__more-list div-table-options-list-js dropdown-js hidden-js">
			<li tabindex="-1" role="button" class="roll-out-js">{{translations.RollOutEverything}}</li>
			<li tabindex="-1" role="button" class="roll-up-js">{{translations.RollUpEverything}}</li>
		</ul>
    </div>	
</div>
`